import { Component, ViewChildren, QueryList, inject, ChangeDetectionStrategy } from '@angular/core';
import {
  MAT_DIALOG_DATA,
  MatDialogContent,
  MatDialogActions,
  MatDialogClose,
} from '@angular/material/dialog';
import { MatFormField } from '@angular/material/form-field';
import { HttpService } from 'src/app/services/core/http.service';
import { AmplitudeService } from 'src/app/services/core/amplitude.service';
import { CdkScrollable } from '@angular/cdk/scrolling';
import {
  MatFormField as MatFormField_1,
  MatLabel,
  MatPrefix,
  MatInput,
} from '@angular/material/input';
import { MatIcon } from '@angular/material/icon';
import { FormsModule } from '@angular/forms';
import { MatButton } from '@angular/material/button';
import { TranslateModule } from '@ngx-translate/core';

@Component({
  selector: 'app-forgot-pass-dialog',
  templateUrl: 'forgot-pass-dialog.html',
  changeDetection: ChangeDetectionStrategy.Eager,
  imports: [
    CdkScrollable,
    MatDialogContent,
    MatFormField_1,
    MatLabel,
    MatPrefix,
    MatIcon,
    MatInput,
    FormsModule,
    MatDialogActions,
    MatButton,
    MatDialogClose,
    TranslateModule,
  ],
})
export class ForgotPassDialog {
  data = inject(MAT_DIALOG_DATA);
  private http = inject(HttpService);
  private amplitudeService = inject(AmplitudeService);

  @ViewChildren(MatFormField) formFields: QueryList<MatFormField>;

  public username: string;

  public sucess = false;
  public loading = false;

  async reset_pass() {
    this.loading = true;
    const response = await this.http.maestroUnauthPost('request_reset_password', {
      username: this.username,
    });
    // resposta neutra: não revela se o usuário/e-mail existe
    this.sucess = true;
    if (response.status) {
      this.amplitudeService.sendEvent('Alterou Senha', { Username: this.username });
    }
    this.loading = false;
  }
}
